import { render, staticRenderFns } from "./form.vue?vue&type=template&id=cf8d2336&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=cf8d2336&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8d2336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf8d2336')) {
      api.createRecord('cf8d2336', component.options)
    } else {
      api.reload('cf8d2336', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=cf8d2336&scoped=true&", function () {
      api.rerender('cf8d2336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/merge_assessment_account_management/merge_assessment/editForm/form.vue"
export default component.exports